import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { publicApi, setApiRole } from "../api/api";
import logo from "../assets/images/vedic-wisdom-logo.png";

const Spinner = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: 24,
    }}
  >
    <div
      style={{
        border: "6px solid #ffe0b2",
        borderTop: "6px solid #f57c00",
        borderRadius: "50%",
        width: 48,
        height: 48,
        animation: "spin 1s linear infinite",
      }}
    />
    <style>
      {`@keyframes spin { 0% { transform: rotate(0deg);} 100% { transform: rotate(360deg);} }`}
    </style>
  </div>
);

const PaymentCallback = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [response, setResponse] = useState(null);
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    // Extract code from URL fragment (e.g., #code=...)
    const fragment = window.location.hash;
    let code = null;
    if (fragment.startsWith('#code=')) {
      code = fragment.replace('#code=', '');
    } else if (fragment.includes('code=')) {
      code = fragment.split('code=')[1];
    }
    if (!code) {
      setError('No payment code found in URL');
      setLoading(false);
      return;
    }
    publicApi
      .post("/payment-session", { code })
      .then((res) => {
        setResponse(res.data);
        setSuccess(true);
        setLoading(false);
        setRedirecting(true);
        const { orderId, user, token } = res.data.data;
        // If tokens are present, log in user

        localStorage.setItem("userRefreshToken", token.refreshToken);
        localStorage.setItem("userAccessToken", token.accessToken);
        localStorage.setItem("user", JSON.stringify(res.data.data.user));
        setApiRole("user");

        const formattedOrderId = String(orderId).padStart(6, "0");
        setTimeout(() => {
          navigate(`/order-success/ORD_${formattedOrderId}`);
        }, 1200);
        // Navigate to OrderSuccess page with response
      })
      .catch((err) => {
        setError(
          err.response?.data?.error || "Payment session retrieval failed"
        );
        setLoading(false);
      });
  }, [navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#fff",
      }}
    >
      <img
        src={logo}
        alt="Vedic Wisdom Logo"
        style={{ width: 200, marginBottom: 32 }}
      />
      {loading && (
        <>
          <div
            style={{
              fontSize: 22,
              fontWeight: 600,
              color: "#3E2723",
              marginBottom: 18,
            }}
          >
            Processing payment
          </div>
          <Spinner />
        </>
      )}
      {error && (
        <div
          style={{
            color: "red",
            fontSize: 18,
            marginTop: 18,
          }}
        >
          Error: {error}
        </div>
      )}
      {redirecting && !error && (
        <>
          <div
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "#3E2723",
              marginBottom: 18,
            }}
          >
            Redirecting...
          </div>
          <Spinner />
        </>
      )}
    </div>
  );
};

export default PaymentCallback;
